import React, { useMemo, useState } from 'react'

import { Checkbox, Button } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import {
  func, shape, bool, number, string, oneOfType,
} from 'prop-types'

import { MULTIPLE_PARTS_DEFAULTS } from 'Pods/Profile/Products/ModelUploader/Components/constants'
import Icon from 'Pods/Shared/Icon/Icon'
import MultiplePartsModal from 'Pods/Shared/MultiplePartsModal/MultiplePartsModal'

function PreSupported({
  printableTechDetails,
  onDetailsChange: handleDetailChange,
  onMultipleDetailsChange: handleMultipleDetailsChange,
}) {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const isPreSupported = printableTechDetails?.isPreSupported || false
  const isSplitIntoMultipleParts = printableTechDetails?.isSplitIntoMultipleParts || false

  const multiplePartsDetails = useMemo(
    () => ({
      ...MULTIPLE_PARTS_DEFAULTS,
      ...printableTechDetails?.multiplePartsDetails,
    }),
    [printableTechDetails],
  )

  const multiplePartsLabel = useMemo(() => {
    const parsedNumber = Number(multiplePartsDetails.numberOfParts)

    if (!Number.isNaN(parsedNumber) && parsedNumber > 0) {
      return `Model is split into ${parsedNumber} parts`
    }

    return 'Model is split into multiple parts'
  }, [multiplePartsDetails.numberOfParts])

  function handlePreSupportedChange() {
    const nextValue = !isPreSupported

    handleDetailChange('isPreSupported', nextValue)
  }

  function handleMultiplePartsChange() {
    const nextValue = !isSplitIntoMultipleParts

    if (!nextValue) {
      handleMultipleDetailsChange({
        isSplitIntoMultipleParts: nextValue,
        multiplePartsDetails: { ...MULTIPLE_PARTS_DEFAULTS },
      })
      return
    }

    handleDetailChange('isSplitIntoMultipleParts', nextValue)
    setIsModalOpen(true)
  }

  function handleModalOpen() {
    setIsModalOpen(true)
  }

  function handleModalClose() {
    setIsModalOpen(false)
  }

  function handleMultiplePartsDetailsSave(formValues) {
    handleMultipleDetailsChange({
      isSplitIntoMultipleParts: true,
      multiplePartsDetails: formValues,
    })
    setIsModalOpen(false)
  }

  return (
    <div className="col-12 col-sm-6 col-md-6 col-xl-4">
      <Checkbox
        id="pre-supported"
        label="Pre-supported or supports are not needed"
        isChecked={isPreSupported}
        onChange={handlePreSupportedChange}
        isControlled
      />
      <div className="multiple-parts-row">
        <Checkbox
          id="multiple-parts"
          label={multiplePartsLabel}
          isChecked={isSplitIntoMultipleParts}
          onChange={handleMultiplePartsChange}
          isControlled
        />
        {isSplitIntoMultipleParts && (
          <Button
            actionType="button"
            size="small"
            onClick={handleModalOpen}
            variant="primary"
            icon={<Icon type={['far', 'exclamation-triangle']} className="mr-5" />}
          >
            Edit details
          </Button>
        )}
      </div>
      <MultiplePartsModal
        isOpen={isModalOpen}
        onClose={handleModalClose}
        onSave={handleMultiplePartsDetailsSave}
        details={multiplePartsDetails}
      />
    </div>
  )
}

PreSupported.propTypes = {
  printableTechDetails: shape({
    isPreSupported: bool,
    isSplitIntoMultipleParts: bool,
    multiplePartsDetails: shape({
      numberOfParts: oneOfType([number, string]),
      unit: string,
      width: oneOfType([number, string]),
      depth: oneOfType([number, string]),
      height: oneOfType([number, string]),
      assemblyInstructions: string,
    }),
  }).isRequired,
  onDetailsChange: func.isRequired,
  onMultipleDetailsChange: func.isRequired,
}

export default PreSupported
